module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-results-filters-collapse-box collapse in"
  }, [_c('div', {
    staticClass: "ibox-results-filters"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.$user.isAdminOrCoordinator) ? _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("User")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.initialUserOptions,
      "name": "user",
      "fetch-results": _vm.fetchUserResults
    },
    model: {
      value: (_vm.user_id),
      callback: function($$v) {
        _vm.user_id = $$v
      },
      expression: "user_id"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "..."
    },
    on: {
      "input": _vm.updateSearch
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-truck"
  }, _vm._l((_vm.trucks), function(truck) {
    return _c('li', {
      key: truck.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'trucks.edit',
          params: {
            id: truck.id
          }
        }
      }
    }, [(truck.thumbnail_url) ? _c('img', {
      attrs: {
        "src": truck.thumbnail_url,
        "alt": "truck"
      }
    }) : _vm._e(), _vm._v(" "), _c('h2', {
      staticClass: "truncate"
    }, [_c('strong', [_vm._v(_vm._s(truck.registration))])]), _vm._v(" "), _c('p', {
      staticClass: "truncate"
    }, [_c('strong', [_vm._v(_vm._s(truck.make_and_model))])]), _vm._v(" "), _c('ul', {
      staticClass: "details"
    }, [(truck.location) ? _c('li', [_c('span', [_vm._v("Depot:")]), _vm._v(" " + _vm._s(truck.location.name) + "\n                ")]) : _vm._e(), _vm._v(" "), (truck.driver) ? _c('li', [_c('span', [_vm._v("Driver:")]), _vm._v(" " + _vm._s(truck.driver ? ((truck.driver.profile.name) + " " + (truck.driver.profile.surname)) : '') + "\n                ")]) : _vm._e()])])], 1)
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoTrucks),
      expression: "haveNoTrucks"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("There are no trucks.")])])]), _vm._v(" "), _c('lazy-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveTrucks),
      expression: "haveTrucks"
    }],
    ref: "lazyLoading",
    attrs: {
      "reached-bottom": _vm.getTrucksForNextPage,
      "filters": _vm.filters
    }
  }, [_c('strong', {
    staticClass: "text-muted",
    slot: "finished"
  }, [_vm._v("There are no more trucks.")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ibox-results-collapse visible-xs",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "href": ".ibox-results-filters-collapse-box",
      "aria-expanded": "false",
      "aria-controls": "ibox-results-filters-collapse-box"
    }
  }, [_vm._v("\n\t\t\t\tShow Filters "), _c('i', {
    staticClass: "fa fa-bars"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-08a83e5d"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/trucks/Trucks.vue
// module id = 925
// module chunks = 0